export const COMPETITION_UPCOMING_STATUS = 'UPCOMING';
export const COMPETITION_ONGOING_STATUS = 'ONGOING';
export const COMPETITION_COMPLETED_STATUS = 'COMPLETED';

export const competitionStatus = {
  [COMPETITION_UPCOMING_STATUS]: 'Upcoming',
  [COMPETITION_ONGOING_STATUS]: 'Ongoing',
  [COMPETITION_COMPLETED_STATUS]: 'Completed',
};
